import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import _includes from 'lodash.includes';
import _isEmpty from 'lodash.isempty';
import { List, Icon, Button, Grid, Header } from 'semantic-ui-react';

// Actions
import { starList, unstarList } from '../actions/actions_user';
import { toggleMsgStarredMaximum } from '../actions/actions_view';

// React component
class ChecklistHeader extends React.Component {
	constructor(props) {
		super(props);
		this.handleStarring = this.handleStarring.bind(this);
	}

	handleStarring(e) {
		e.preventDefault();

		if (this.props.starred === false && this.props.starredMaximum === true) {
			// going to star list but
			// maximum of starred lists reached, inform user
			this.props.toggleMsgStarredMaximum(true);
		} else if (this.props.starred === false && this.props.starredMaximum === false) {
			// star list
			this.props.starList(this.props.userId, this.props.listId);
		} else {
			// unstar list
			this.props.toggleMsgStarredMaximum(false);
			this.props.unstarList(this.props.userId, this.props.listId);
		}
	}

	render() {
		let { name, starred, backButton, goToButton } = this.props;
		console.log('back link', backButton);

		return (
			<List.Content>
				{backButton === true &&
					this.props.userLoaded && (
						<Grid className="header-style main-header">
							<Grid.Row columns={3} verticalAlign="middle">
								<Grid.Column width={2}>
									<Button as={Link} to={`/lists`} icon basic id="back-button">
										<Icon name="arrow left" />
									</Button>
								</Grid.Column>

								<Grid.Column width={12}>
									<Header as="h1" textAlign="center">
										{name}
									</Header>
								</Grid.Column>
								<Grid.Column width={2}>
									<div className="star" onClick={this.handleStarring}>
										{starred === false ? <Icon name="star outline" /> : <Icon name="star" />}
									</div>
								</Grid.Column>
							</Grid.Row>
						</Grid>
					)}

				{backButton === false &&
					this.props.userLoaded && (
						<div className="star-lists" onClick={this.handleStarring}>
							{starred === false ? <Icon name="star outline" /> : <Icon name="star" />}
						</div>
					)}

				{goToButton === true && <List.Header className="list-header-inline">{name}</List.Header>}
			</List.Content>
		);
	}
}

// Map Redux state to component props
const mapStateToProps = (state, ownProps) => {
	console.log('ownprops of collapsed:', ownProps);

	return {
		userId: state.user.userId,
		starred: _includes(state.user.starredLists, ownProps.listId) ? true : false,
		userLoaded: _isEmpty(state.user.userId) ? false : true,
		starredMaximum: state.user.starredMaximum
	};
};

export default connect(
	mapStateToProps,
	{ starList, unstarList, toggleMsgStarredMaximum }
)(ChecklistHeader);



// WEBPACK FOOTER //
// ./src/components/ChecklistHeader.js